<template>
  <section class="SectionPortfolio">
    <Wrap>
      <Headline>
        {{ $t('headline') }}
      </Headline>
      <CarouselGallery class="gallery" :images="media" />
    </Wrap>
  </section>
</template>

<script>
import CarouselGallery from 'views/components/CarouselGallery'

export default {
  components: { CarouselGallery },
  props: {
    media: Array,
  },
}
</script>

<style lang="scss">
.SectionPortfolio {
  .gallery {
    margin: 5rem 0;
  }
}
</style>

<i18n>
{
    "lt": {
        "headline": "Įgyvendinti projektai"
    }
}
</i18n>
